import { Component, OnInit, ElementRef, ViewChild, Input, Self, Output, EventEmitter } from '@angular/core';
import { NgControl, Validators, AbstractControl } from '@angular/forms';
import { BankAccountService } from 'src/app/accounting/banking/bank-register/bank-register.service';

@Component({
  selector: 'select-field-bank-account',
  templateUrl: './select-field-bank-account.component.html',
  styleUrls: ['./select-field-bank-account.component.scss']
})
export class SelectFieldBankAccountComponent implements OnInit {

  @ViewChild('select', {static: true}) select: ElementRef;

  // inputs
  @Input() label: string = 'Bank Account';
  @Input() required: boolean = false;
  @Input() fieldError: string;
  @Input() isSubmitted = false;

  @Output() ready: EventEmitter<any> = new EventEmitter();

  // options data
  options = null;

  constructor(
    @Self() public ngCtrl: NgControl,
    private _bankAccountSvc: BankAccountService
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit() {

    const ctrl = this.ngCtrl.control;
    this.select.nativeElement.value = '';

    this._bankAccountSvc.getBankAccounts();
    this._bankAccountSvc.BankAccounts.subscribe((res: any) => {
      if (res) {
        this.options = res;
        if (ctrl.value) {
          setTimeout(() => {
            this.writeValue(ctrl.value);
          }, 100);
        }
        this.ready.emit();
      }
    });

  }

  onSelectChange(value: any) {
    this.onChange(value);
  }

  onChange(_value: any) {}

  onTouched() {}

  writeValue(value: any) {
    this.select.nativeElement.value = value;
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }

}
